import { captureException } from '@sentry/browser';
import { ONE_SECOND_MS } from '@shared/utils/constants';

const MAX_RETRIES = 10;
const RETRY_DELAY_MS = ONE_SECOND_MS * 2;

export async function safeSentryCaptureException(error: Error) {
  let attempt = 0;
  while (attempt < MAX_RETRIES) {
    try {
      captureException(error);
      break;
    } catch (ex) {
      attempt++;
      const delay = Math.pow(2, attempt) * RETRY_DELAY_MS;
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}
